import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group } from 'src/app/common-class/pages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemographicsComponent implements OnInit {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() DropDown: string;
  @Input() isMobile: boolean;
  @Input() MonthArray:string[];
  @Input() isNewParticipationButton: boolean;
  @Input() isResponseUpdate: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  isNgAfter: boolean;
  count: number = 0;
  dropDownlength : number;
  isNewParticipation: boolean;
  surveyFormat:number = 0;
  newParticipationBtnText: string;
  isAnsChange: boolean = false;
  isAutoScroll: boolean;
  isPreReadQn: boolean;
  resetPageSub: any;
  isResetPage: boolean = false;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    if (change != undefined) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);

      if (curVal != preVal && preVal != undefined  && (this.isResetPage || this.isQuesionHideInQDL())) {
        this.questions = JSON.parse(this.JsonData);
        this.isNgAfter = true;
        this.count = 0;
        this.ngAfterViewInit();
        this.isResetPage = false;
      }
    }
  }

  constructor(private service: ParticipationDataService) {
  }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      if(this.group.answer_style == 0 && this.questions.length > 1)
      {
       this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      }

      let imgQn = this.questions.find(e => e.sub_qno == 1);
      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }
      this.dropDownlength = this.questions.length;
    }
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.isAutoScroll = this.service.isAutoScroll;
    this.isPreReadQn = this.questions.filter(e => e.population_type == 3).length>0;
  }

  ngAfterViewInit(){
    var self=this;
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    let id = "dv_" + this.imgQuestion.UniqueNumber;
    let largestWidth = 0;
    let ReEnterWidth =0;

    setTimeout(function() {
      $('#' + id).find('.demographics-wrapper').each(function(i) {
        let currentWidth = $(this).find('.question-option-wrapper').outerWidth();


        if(currentWidth > largestWidth){
          largestWidth = currentWidth;
        }
        if($(this).find('.question-option-wrapper.reenter'))
        {
          ReEnterWidth = $(this).find('.question-option-wrapper.reenter').outerWidth();
        }


      });
      if(largestWidth < ReEnterWidth){
        largestWidth = ReEnterWidth;
      }

      if(largestWidth > 400){
        largestWidth = 400;
      }
      if(!self.isMobile)
      {
        $('#' + id).find('.demographics-wrapper').find('.question-option-wrapper').outerWidth(largestWidth);
        $('#' + id).find('.demographics-wrapper').find('.question-option-wrapper').css('min-width', largestWidth + 'px');
        $('#' + id).find('.demographics-wrapper').find('.question-option-wrapper').css('max-width', largestWidth + 'px');
      }
      $('#' + id).find('.demographics-wrapper').find('.question-option-wrapper').css('white-space', 'normal');
    }, 100);
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange = false;
        this.isResetPage = true;
      }
    });
  }

  ngOnDestroy(){
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  isQuesionHideInQDL(): boolean {
    return true;
    if (this.questions.find(e => e.isCQ && e.isCQHide) != undefined) {
      return true;
    } else {
      return false;
    }
  }

  UpdateQuestionsData(question: Questions) {
    if(question.AnswerText!=null){
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
    let qn = this.questions.find(e => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;
  }
  UpdateLoadingQuestionsData(question: Questions) {
    if(question.AnswerText!=null){
      this.isAnsChange = true;
    }
    this.ChangeLoadingAnswersData.emit(question);
    let qn = this.questions.find(e => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;
  }

  AnsChangecall(isAnsChangecall: boolean) {
    this.isAnsChange = isAnsChangecall;
  }

  GetQuestionsString(question): string {
    return JSON.stringify(this.questions.find(e => e.UniqueNumber == question.UniqueNumber));
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  getHiddenQuestions(questions:Questions,service: ParticipationDataService)
  {
    if(service.getGroupType().toLowerCase() == "preview" && service.getPreviewData().isShowHiddenQN){
      return true;
    }
    else{
      return (questions.population_type != 2 && questions.population_type != 5 && questions.isCQHide==false );
    }
  }

  ngOnChangesEventHandle() {
    if (this.count == 0) {
      this.ngAfterViewInit();
      this.count++;
    }
  }

  getDemoClass(question: Questions){
    switch(question.DemographicFieldID){
      case 1:return "demoTitle"
      break;
      case 2:return "demoFName"
      break;
      case 21: return  "demoFullName"
      break;
      case 3:return "demoMName"
      break;
      case 4:return "demoLName"
      break;
      case 5:return  "demoGender"
      break;
      case 7: return  "demoDOB"
      break;
      case 91:return  "demoStreet1"
      break;
      case 92:return  "demoStreet2"
      break;
      case 81: return "demoAddress1"
      break;
      case 82: return "demoAddress1"
      break;
      case 83:
      case 93:return  "demoCity"
      break;
      case 86:return "demoCountry"
      break;
      case 94:return  "demoCounty"
      break;
      case 84:
      case 95:return  "demoState"
      break;
      case 85:
      case 96:return  "demoZip"
      break;
      case 97:return  "demoZip4"
      break;
      case 101:
      case 10:return  "demoTelePhone"
      break;
      case 221:
      case 22:return  "demoExtc"
      break;
      case 232:
      case 23:return  "demoFax"
      break;
      case 11:return  "demoEmail"
      break;
      default:return ""
      break;
    }
  }
  gotoNextQuestion(question: Questions, event) {
    if (this.questions.filter(e => e.isValid).length == 0 &&
      this.questions.filter(e => e.isValid == false && e.qtype == 'T' && e.qsubtype == 31 && e.isreenter == 1 && e.otherAnswer == null && e.AnswerText != null).length == 0) {
      this.service.gotoNextQuestion(question, event);
    }
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

}
